import i18next, { t } from "i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ArrowIcon from "../../../assets/images/icons/arrow-down.svg";
import { setMedicalRecord } from "../../../redux/reducers/medicalRecordSlice";
import CancelMedicalRecord from "../component/CancelMedicalRecordModal/CancelMedicalRecordModal";

const MedicalRecordHeader = ({
  selectedTemplateName,
  title,
  backRoute,
  onBack
}: {
  selectedTemplateName?: string;
  title?: string;
  backRoute?: string | number;
  type?: string;
  onBack?:any
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type } = useParams();
  const location = useLocation();

  const handleBack = () => {
    navigate(location.state?.from || -1);
    
  };

  const isCustomizeTemplate = type === "customize";
  const isViewTemplate = type === "details";

  return (
    <div className="flex justify-between">
      <div className="flex cursor-pointer items-center gap-4">
        {title === t("add_medical_report") && type !== "details" ? (
          <CancelMedicalRecord
            arrowStyle
            onClick={() => {
              onBack && onBack()
              backRoute ? navigate(`${backRoute}`) : handleBack();
              dispatch(setMedicalRecord(null));
            }}
          />
        ) : (
          <div
            onClick={() => {
              onBack && onBack()
              backRoute ? navigate(`${backRoute}`) : handleBack();
              dispatch(setMedicalRecord(null));
            }}
            className="h-6 w-6 rounded-full bg-primary"
          >
            <img
              src={ArrowIcon}
              alt=""
              className={`*:first-letter brightness-0 invert ${
                i18next?.language === "ar" ? "-rotate-90" : "rotate-90"
              } `}
            />
          </div>
        )}
        {!isCustomizeTemplate ? (
          <h1 className="text-xl font-bold">
            {title
              ? title
              : isViewTemplate
                ? t("view_medical_report")
                : t("add_medical_report")}
          </h1>
        ) : (
          <h2 className="text-xl font-bold">{t("customize")}</h2>
        )}

        {selectedTemplateName && (
          <div className="bg-radio min-h-6 min-w-20 rounded-lg px-2 py-1 text-sm font-semibold">
            {selectedTemplateName}
          </div>
        )}
      </div>
      <div className="flex items-center gap-10">
        <div className="w-96 max-xl:hidden" />
      </div>
    </div>
  );
};

export default MedicalRecordHeader;
